export default __webpack_public_path__ + "static/paleto_forest_bunker-e7892786242224e35706f40337cf19b2.png";